import constants from 'Base/shared/bk/modules/constants';
import axios from 'axios';

class BaseApi {
    constructor({ csrf } = {}) {
        this.csrf = csrf;
        this.axiosInstance = axios.create();
        this.axiosInstance.interceptors.request.use((config) => {
            config.headers['X-CSRF-TOKEN'] = this.csrf;
            config.headers['Content-Type'] = 'application/json';

            return config;
        });
        this.axiosInstance.interceptors.response.use(
            (response) => {
                return response?.data;
            },
            (error) => {
                if (error.response) {
                    const errorMessage = error.response.data.message;
                    if (errorMessage) {
                        return Promise.reject(new Error(errorMessage));
                    }
                } else if (error.request) {
                    return Promise.reject(new Error('Network error'));
                }

                return Promise.reject(error);
            },
        );
        this.baseUrl = constants.contextPath;
    }
}

export default BaseApi;
